import { Input } from './input';
import type { ContainerProps, InputProps } from './type';

import { FormControl, FormItem, FormMessage } from '../form';

export const FormInput = ({
  formItemClassName,
  messageProps,
  forceHideMessage = false,
  ...props
}: InputProps & {
  formItemClassName?: string;
  messageProps?: ContainerProps;
  forceHideMessage?: boolean;
}) => (
  <FormItem className={formItemClassName}>
    <FormControl>
      <Input {...props} />
    </FormControl>
    {!forceHideMessage && <FormMessage {...messageProps} />}
  </FormItem>
);
